import { useQuery } from '@tanstack/react-query'
import { RoleType } from '@portal/pkg-api/gen/admin'
import { RolesApi } from '@portal/pkg-api/admin'
import { data } from '@portal/pkg-api/shared'

const prefix = 'admin.roles'

export const RoleQueries = {
  roles: () => ({
    queryKey: [`${prefix}.roles`],
    queryFn: () => data(RolesApi.getRoles()),
  }),
  rolesByType: (dtype: RoleType) => ({
    queryKey: [`${prefix}.rolesByType`, dtype],
    queryFn: async () => {
      const roles = await data(RolesApi.getRoles())
      return roles.filter((role) => role.dtype === dtype)
    },
  }),
}

export function useRoles() {
  return useQuery(RoleQueries.roles())
}

export function useRolesByType(dtype: RoleType) {
  return useQuery(RoleQueries.rolesByType(dtype))
}
